<template>
  <InsideContent
    :title="$t('APP.IAB.TITLE')"
    :hint="$t('HINTS.APPS.PAYMENT.IAB')"
    :description="$t('APP.IAB.DESC')"
  >
    <FormSection
      :title="$t('APP.IAB.RSA_TITLE')"
      :description="$t('APP.IAB.RSA_DESC')"
      :hint="$t('HINTS.APPS.PAYMENT.RSA')"
    >
      <Card v-loading="rsaKeyLoading">
        <small class="text-disabled hide-for-medium">
          {{ $t('TAP_TO_SELECT') }}:
        </small>

        <CodeBlock :content="rsaKey" />
      </Card>
    </FormSection>

    <FormSection
      :description="$t('APP.IAB.DYNAMIC_PRICE_DESC')"
      :has-edit="false"
      :is-edit-mode="false"
      :title="$t('APP.IAB.DYNAMIC_PRICE_KEY_TITLE')"
    >
      <Card v-loading="dynamicPriceKeyLoading">
        <CodeBlock :content="dynamicPriceKey" style="margin-bottom: 1rem" />

        <ElButton
          icon="el-icon-refresh-left"
          native-type="button"
          type="danger"
          @click="renewDynamicPriceKey"
        >
          {{ $t('APP.IAB.RENEW_DYNAMIC_PRICE_KEY_BTN') }}
        </ElButton>
      </Card>
    </FormSection>
  </InsideContent>
</template>

<script>
import InsideContent from '@@/common/layout/InsideContent';
import FormSection from '@@/common/layout/FormSection';
import { Apps } from '@/api/api';
import Card from '@@/common/Card';
import CodeBlock from '@@/common/CodeBlock';
import packageNameWatch from '@/mixins/apps/packageNameWatch';
import packageName from '@/mixins/packageName';
import selection from '../../../directives/selection';

export default {
  name: 'InAppBillingSettings',

  directives: {
    selection,
  },

  components: {
    InsideContent,
    FormSection,
    Card,
    CodeBlock,
  },

  mixins: [packageNameWatch, packageName],

  data() {
    return {
      rsaKey: '',
      rsaKeyLoading: true,
      dynamicPriceKey: '',
      dynamicPriceKeyLoading: true,
    };
  },

  created() {
    this.getInfo();
  },

  methods: {
    getInfo() {
      this.getRSAKey();
      this.getDynamicPriceKey();
    },

    getRSAKey() {
      return Apps.getRSAKey({ packageName: this.packageName })
        .then(({ body: { rsa } }) => {
          this.rsaKey = rsa;
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.rsaKeyLoading = false;
        });
    },

    getDynamicPriceKey() {
      return Apps.getDynamicPriceKey({ packageName: this.packageName })
        .then(({ body: { key } }) => {
          this.dynamicPriceKey = key;
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.dynamicPriceKeyLoading = false;
        });
    },

    renewDynamicPriceKey() {
      this.dynamicPriceKeyLoading = true;
      return Apps.renewDynamicPriceKey({ packageName: this.packageName }, {})
        .then(({ body: { new_key } }) => {
          this.dynamicPriceKey = new_key;
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.dynamicPriceKeyLoading = false;
        });
    },
  },
};
</script>
